import { CheckboxProps } from '@shopify/polaris';
import { FunctionComponent, useCallback, useEffect, useState } from 'react';

import { checkBoxRoundedCss } from '@styles/css';
import styled from 'styled-components';
import CheckboxInput from '../checkbox';
import { Container } from '../container/common';

const MainContainer = styled(Container)`
  padding: 2rem 0;
  ${checkBoxRoundedCss}

  & :first-child {
    padding: 0 0 2rem 0;
  }

  & :last-child {
    padding: 0;
  }
`;

const Content = styled(Container)`
  padding: 2rem 0 0 0;
`;

const CheckboxContainer: FunctionComponent<CheckboxProps> = ({
  children,
  onChange,
  ...checkboxProps
}) => {
  const [checked, setChecked] = useState(checkboxProps.checked);
  const handleChange = useCallback(
    (newChecked, id) => {
      setChecked(newChecked);
      if (onChange) {
        onChange(newChecked, id);
      }
    },
    [onChange],
  );

  useEffect(() => {
    setChecked(checkboxProps.checked);
  }, [checkboxProps.checked]);

  return (
    <MainContainer>
      <CheckboxInput
        {...checkboxProps}
        checked={checked}
        onChange={handleChange}
      />
      {checked && <Content>{children}</Content>}
    </MainContainer>
  );
};

export default CheckboxContainer;
